<form class="w-100" name="authorizeUser" (ngSubmit)="onSubmit()" method="get" accept-charset="utf-8">
  <div class="container-fluid">
    @if (error != null && error != '') {
      <div>
        <p class="text-danger row justify-content-center">
          {{error}}
        </p>
        <p class="row justify-content-center">
          If you feel you've received this in error, please contact&nbsp;<a href="mailto:scohr@sjcoe.net">scohr&#64;sjcoe.net</a>
        </p>
      </div>
    }
    @if (guid != null) {
      <div class="justify-content-center">
        <p>
          You are authorizing the below user access to SCOHR for this fiscal year. Please press Confirm to continue.
        </p>
        <dl>
          <dt>Name</dt>
          <dd>{{fullName}}</dd>
          <dt>Email</dt>
          <dd>{{email}}</dd>
          <dt>Level</dt>
          <dd>{{type}}</dd>
        </dl>
      </div>
    }
    @if (guid != null) {
      <div class="row justify-content-center">
        @if (!hideConfirm) {
          <div class="input-group mb-3 col-lg-6">
            <button role="button" aria-label="Submit" class="btn btn-primary"
            type="submit" name="submit" id="button-addon2">Confirm</button>
          </div>
        }
        @if (hideConfirm) {
          <p>
            User Confirmed. Thank you.
          </p>
        }
      </div>
    }
  </div>
</form>
